'use client';
import {IconButton} from './IconButton';
import Link from 'next/link';
import {PepIcon} from './PepIcon';
import {BodyText, Heading1} from './Text';
import {useRef} from 'react';
import {useFeatureFlagStore} from '../store/featureFlagsStore';
import {EventSubmissionSvg} from './EventSubmissionSvg';
import {useEventsSettings} from '../store/eventsSettingsStore';

export default function SubmitYourEvent() {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const featureFlags = useFeatureFlagStore();
  const eventsSettings = useEventsSettings();

  const {eventSubmissionDescription, eventSubmissionTitle, eventSubmissionWebsiteLabel, eventSubmissionWebsiteUrl} =
    eventsSettings;

  if (
    !featureFlags.featureFlags.web.displayEventSubmissionModal ||
    !eventSubmissionWebsiteUrl ||
    !eventSubmissionTitle ||
    !eventSubmissionDescription ||
    !eventSubmissionWebsiteLabel
  ) {
    return null;
  }

  const showModal = () => {
    console.log('showModal');
    dialogRef.current?.showModal();
  };
  const closeModal = () => {
    console.log('closeModal');
    dialogRef.current?.close();
  };

  return (
    <>
      <IconButton
        pepIcon="Add"
        variant="secondary"
        onClick={showModal}
        className="flex"
        active
        label={eventSubmissionTitle}
      />
      <dialog
        ref={dialogRef}
        className="dark/75 rounded-2xl bg-background p-4 backdrop:bg-midground4/75 md:max-w-[66%] xl:max-w-[48%]"
      >
        <div className="flex justify-end">
          <button onClick={closeModal}>
            <span className="sr-only">Close modal</span>
            <PepIcon iconName={'Remove'} strokeColor="foreground" aria-hidden />
          </button>
        </div>
        <div className="flex flex-col items-center gap-6 p-8">
          <EventSubmissionSvg aria-hidden />

          <Heading1 className="mt-5">{eventSubmissionTitle}</Heading1>

          <BodyText className="text-center">{eventSubmissionDescription}</BodyText>

          <Link target="_blank" href={eventSubmissionWebsiteUrl}>
            <IconButton
              autoFocus
              className="flex"
              pepIcon="Hyperlink"
              label={eventSubmissionWebsiteLabel}
              onClick={() => undefined}
              active
            />
          </Link>
        </div>
      </dialog>
    </>
  );
}
